/**
 * Analytics module — sends events to Lambda/DynamoDB backend.
 * Batches events and sends every 5s or on page unload.
 */

const ANALYTICS_URL = "https://t1tw0cwa38.execute-api.us-east-1.amazonaws.com/events";
const BATCH_INTERVAL = 5000; // 5 seconds
const MAX_BATCH = 20;

let queue = [];
let timer = null;

function getUser() {
  try {
    const session = JSON.parse(localStorage.getItem("uc_auth_session") || "{}");
    return session.username || "anon";
  } catch {
    return "anon";
  }
}

function flush() {
  if (queue.length === 0) return;
  const batch = queue.splice(0, MAX_BATCH);
  const payload = JSON.stringify({ events: batch });

  // Use sendBeacon for reliability on page unload, fetch otherwise
  if (navigator.sendBeacon) {
    navigator.sendBeacon(ANALYTICS_URL, payload);
  } else {
    fetch(ANALYTICS_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {}); // silent fail
  }
}

function startTimer() {
  if (timer) return;
  timer = setInterval(flush, BATCH_INTERVAL);
}

function enqueue(event) {
  queue.push({
    ...event,
    usuario: event.usuario || getUser(),
    timestamp: new Date().toISOString(),
  });
  startTimer();
  if (queue.length >= MAX_BATCH) flush();
}

// Flush on page unload
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", flush);
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}

// --- Public API ---

export function trackLogin(username) {
  enqueue({ event: "login", usuario: username });
}

export function trackLogout(username) {
  enqueue({ event: "logout", usuario: username });
  flush(); // immediate
}

export function trackPageView(ruta) {
  enqueue({ event: "page_view", ruta });
}

export function trackMenuClick(item) {
  enqueue({ event: "menu_click", item });
}

export function trackCotizadorQuery(data) {
  enqueue({
    event: "cotizador_query",
    ambito: data.ambito,
    prestacion_cod: data.prestacion_cod,
    prestacion_nombre: data.prestacion_nombre,
    isapre: data.isapre,
    seguro_comp: data.seguro_comp,
    p50: data.p50,
    n_observaciones: data.n_observaciones,
    pct_copago_0: data.pct_copago_0,
  });
}

export function trackEstimadorQuery(data) {
  enqueue({
    event: "estimador_query",
    ambito: data.ambito,
    prestacion_cod: data.prestacion_cod,
    prestacion_nombre: data.prestacion_nombre,
    isapre: data.isapre,
    seguro_comp: data.seguro_comp,
    p50: data.p50,
    n_observaciones: data.n_observaciones,
    pct_copago_0: data.pct_copago_0,
  });
}
